<template>
  <div class="prize">
    <!-- 广告位 -->
    <div class="ads" v-if="downAdv.image">
      <a v-if="downAdv.url != '#'" :href="downAdv.url">
        <img :src="downAdv.image" alt />
      </a>
      <img v-else :src="downAdv.image" alt />
    </div>

    <div class="box" id="prize">
      <ul class="luck-draw">
        <li v-for="(item, index) in drawList" :key="index" :class="{ active: index == current }">
          <p class="des1">{{ item.des1 }}</p>
          <p class="des2">{{ item.des2 }}</p>
          <p class="des3">{{ item.des3 }}</p>
          <p class="des4">{{ item.des4 }}</p>
        </li>
      </ul>

      <!-- 抽奖未开始 -->
      <div class="status" v-if="prizeStatus < 2">
        <div class="status-con">
          <p>抽奖将于{{ startTime }}开始</p>
        </div>
        <div class="btn">
          <button class="btn1">抽奖未开始</button>
        </div>
      </div>

      <!-- 抽奖进行中 -->
      <div class="status" v-if="prizeStatus == 2">
        <div class="status-con" v-if="!isLogin">
          <p>签到后才能逛展抽奖哦</p>
        </div>
        <div class="status-con" v-if="isLogin">
          <p v-if="loginCounter < 30">再连续逛展{{ 30 - loginCounter }}分钟即可抽奖</p>
          <!-- //已在线{{ loginCounter }}分钟,您有 {{ drawCount }} 次抽奖机会 -->
          <p v-else>您已满30分钟,有 {{ drawCount }} 次抽奖机会</p>
        </div>
        <div class="btn">
          <button :class="{
              btn1: drawCount == 0 || loginCounter < 30,
              btn2: drawCount > 0 && loginCounter >= 30,
            }" @click="start">开始抽奖</button>
          <!-- <button class="btn4" @click="toDrawHistory">抽奖记录</button> -->
        </div>
      </div>

      <!-- 抽奖结束 -->
      <div class="status" v-if="prizeStatus > 2">
        <div class="status-con">
          <p>活动已结束</p>
        </div>
        <div class="btn">
          <button class="btn3">活动结束(灰色)</button>
          <!-- <button class="btn4" @click="toDrawHistory">抽奖记录</button> -->
        </div>
      </div>

      <!--中奖纪录 -->
      <div class="zjjl">
        <span @click="toDrawHistory">中奖记录</span>
      </div>
      <!-- 抽奖说明 -->
      <div class="cjsm">
        <router-link to="/explain">
          <span>抽奖说明</span>
        </router-link>
      </div>

      <!-- 中奖展示 -->
      <div class="show-draw">
        <swiper class="swiper-container swiper draw1-swiper" v-if="list.length != 0" :options="swiperOptions" ref="mySwiper">
          <swiper-slide class="swiper-slide" v-for="(item, index) in list" :key="index">{{ `${item.mobile}抽中${item.prize}` }}</swiper-slide>
        </swiper>

        <div v-else>
          <div class="line" style="text-align: center;">暂无中奖记录</div>
        </div>
      </div>
    </div>

    <!-- 抽中奖品(中奖展示弹窗) -->
    <div class="tc-bg" v-if="popShow">
      <div class="tc">
        <img class="close" src="@/assets/images/close.png" @click="popShow = false" />
        <img class="qycj_succ_dh" src="@/assets/images/teacher_tc_dh.png" />
        <h4>恭喜您抽中</h4>
        <h6>{{ drawList[current].Title }}</h6>
        <!-- <h6>123}</h6> -->
        <p>具体兑奖方式请与您的留学规划顾问联系</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getPrize, getPrizeInfoList, getDrawTime, baseUrl } from "@/api/home";
export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    downAdv: {
      type: Object,
      defult: {},
    },
    // 抽奖时间状态
    prizeStatus: {
      type: Number,
      default: 0,
    },
    expoId: {
      type: Number,
      default: 0,
    },
    // 逛展抽奖时间戳
    partStartTime: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data() {
    return {
      //奖品列表
      current: -1, //当前索引
      drawList: [
        {
          Id: 201,
          Title: "留学服务费用全免",
          des1: "",
          des2: "",
          des3: "",
        },
        {
          Id: 202,
          Title: "留学服务费用半免",
          des1: "",
          des2: "",
          des3: "",
        },
        {
          Id: 203,
          Title: "留学服务费3500元代金券",
          des1: "",
          des2: "",
          des3: "",
        },
        {
          Id: 205,
          Title: "留学服务费1000元代金券",
          des1: "",
          des2: "",
          des3: "",
        },
        {
          Id: 207,
          Title: "启德考培prepsmith托福模拟机考",
          des1: "",
          des2: "",
          des3: "",
        },
        {
          Id: 205,
          Title: "留学服务费1000元代金券",
          des1: "",
          des2: "",
          des3: "",
        },
        {
          Id: 206,
          Title: "启德考培prepsmith雅思模拟机考",
          des1: "",
          des2: "",
          des3: "",
        },
        {
          Id: 204,
          Title: "留学服务费2000元代金券",
          des1: "",
          des2: "",
          des3: "",
        },
      ],
      // loginCounter: 300,
      loginCounter: 0, //已在线分钟数
      activityStartTime: "",
      award: "",
      popShow: false,
      time: "",
      speed: "",
      diff: "",
      drawCount: 0,
      swiperOptions: {
        slidesPerView: 1, //显示多少条
        spaceBetween: 5, //每条之间间隔
        autoplay: {
          delay: 2000,
        },
        // direction: "vertical",
        // autoHeight: true,
      },
      list: [],
      disabled: false,
      startTime: "", //时间戳转为日月时分
    };
  },
  computed: {},
  // watch:{},
  methods: {
    // 检测登录
    checkLogin() {
      if (!this.isLogin) {
        this.$emit("showLogin");
        return false;
      }
      return true;
    },

    // 获取抽奖次数
    async getTimes() {
      const res = await getDrawTime({
        params: {
          expoId: this.expoId,
        },
      });
      if (res.succ) {
        this.drawCount = parseInt(res.results.drawTime);
      }
      //  else {
      //   alert(res.msg);
      // }
    },

    // 获取抽奖详情
    async getInfoList() {
      const res = await getPrizeInfoList({
        params: {
          expoId: this.expoId,
        },
      });
      // console.log('res', res)
      this.list = res.results;
    },

    //点击开始
    start() {
      console.log("start");
      // 判断是否登录
      if (!this.isLogin) {
        this.$emit("showLogin", "prizeBtn");
        return;
      }

      //判断是否有抽奖次数
      if (this.drawCount == 0) {
        setTimeout(() => {
          alert("您已经没有抽奖次数了");
        }, 100);
        return;
      }

      // 判断是否逛展30分钟
      if (this.loginCounter < 30) {
        setTimeout(() => {
          alert("您还未逛展30分钟");
        }, 100);
        return;
      }

      if (this.disabled) return;
      // 后台请求数据
      this.disabled = true;
      this.drawAward();
      this.time = Date.now();
      this.speed = 150;
      this.diff = 15;
    },

    // 抽奖后台请求中奖结果
    async drawAward() {
      let res = await getPrize({ expoId: this.expoId });
      if (res.succ) {
        this.award = res.results;
        this.getTimes();

        window.location.href = "#prize";
        this.move();
      } else {
        this.disabled = false;
        alert(res.msg);
      }
    },

    // 转动
    move() {
      this.timeout = setTimeout(() => {
        this.current++;
        if (this.current >= this.drawList.length) {
          this.current = 0;
        }

        // 若抽中的奖品id存在，则开始减速转动(6代表中间部分 转动时间)
        if (this.award.Id && (Date.now() - this.time) / 1000 > 2) {
          this.speed += this.diff; // 转动减速

          // 若转动时间超过4秒，并且奖品Id等于小格子的奖品Id，则停下来！
          if (
            (Date.now() - this.time) / 1000 > 6 &&
            this.award.Id == this.drawList[this.current].Id
          ) {
            clearTimeout(this.timeout);
            this.popShow = true;
            this.disabled = false;
            return;
          }

          // 若抽中的奖品不存在，则加速转动
        } else {
          this.speed -= this.diff; // 转动加速
        }

        this.move();
      }, this.speed);
    },

    timeWatching() {
      if (this.timeId) {
        clearTimeout(this.timeId);
      }
      //时间满30分中清除定时器
      if (this.loginCounter >= 30) {
        clearTimeout(this.timeId);
        return;
      }

      if (this.prizeStatus == 2 && this.isLogin) {
        this.timeId = setTimeout(() => {
          ++this.loginCounter;
          this.timeWatching();
          // }, 1000)
        }, 60000);
        //console.log(this.loginCounter);
      }
    },
    // 倒计时30分钟
    initInterval() {
      this.loginCounter =
        parseInt(
          parseInt(
            new Date().getTime() -
              parseInt(window.localStorage.getItem("loginTime"))
          ) /
            60 /
            1000
        ) >= 30
          ? 30
          : parseInt(
              parseInt(
                new Date().getTime() -
                  parseInt(window.localStorage.getItem("loginTime"))
              ) /
                60 /
                1000
            );
    },

    // 点击跳转抽奖记录页面
    toDrawHistory() {
      let prizeStatus = this.prizeStatus;
      if (!this.isLogin) {
        this.$emit("showLogin", "prize");
        return;
      }
      if (prizeStatus < 2) {
        // 抽奖未开始
        alert("抽奖未开始");
        return;
      }
      //抽奖期间
      window.location.href = `${baseUrl}/user/draw_record`;
    },
  },
  created() {
    // console.log(this.downAdv);
    if (this.expoId) {
      this.getInfoList();
    }
  },
  watch: {
    isLogin(newVal) {
      if (newVal) {
        this.timeWatching();
        this.getTimes();
        this.initInterval();
      }
    },
    expoId(newVal) {
      if (newVal) {
        this.getInfoList();
        this.startTime = moment(parseInt(this.partStartTime * 1000)).format(
          "M[月]D[日]H:mm"
        );
      }
    },
    // 逛展抽奖时间状态
    // prizeStatus(newVal, val) {
    //   console.log(newVal, val);
    //   this.prizeStatus = newVal;
    // }
  },
};
</script>

<style lang="less" scoped>
.prize {
  width: 100%;
  background-size: 100% auto;
  position: relative;
  padding-top: 0.3rem;
  // 广告位
  .ads {
    width: 7.02rem;
    height: 1.66rem;
    margin: 0 auto 0.3rem;
    background-size: 100% auto;
    //border: 0.07rem solid #6493ff;
    overflow: hidden;
    border-radius: 0.2rem;
    a {
      width: 100%;
      // height: 1.32rem;
      display: block;
      overflow: hidden;
      border-radius: 0.2rem;
      img {
        width: 100%;
        border-radius: 0.2rem;
      }
    }
  }
  .box {
    background: url(~@/assets/images/draw1_bg.png) no-repeat;
    background-size: 100% auto;
    min-height: 12rem;
    position: relative;
    //margin: 0 0.26rem;
    h3 {
      font-size: 0.34rem;
      font-weight: 900;
      color: #fff;
      text-indent: -999px;
      padding: 0.2rem 0;
      text-align: center;
    }
    .luck-draw {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 3.26rem 0.6rem 0;
      height: 11rem;
      li {
        display: block;
        overflow: hidden;
        //border: 0.04rem solid #e3e3e3;
        border-radius: 0.08rem;
        width: 1.72rem;
        height: 1.72rem;
        text-align: center;
        background: #fff;
        margin-bottom: 0.13rem;
        color: #2d66e8;
        position: absolute;
        &.active {
          border: 0.1rem solid #ffca14;
          border-radius: 0.28rem;
        }
        &:nth-child(1) {
          background: url(~@/assets/images/draw1_img1.png) no-repeat;
          background-size: 100% auto;
          top: 3.5rem;
          left: 1rem;
        }
        &:nth-child(2) {
          background: url(~@/assets/images/draw1_img2.png) no-repeat;
          background-size: 100% auto;
          left: 2.87rem;
          top: 3.5rem;
        }
        &:nth-child(3) {
          background: url(~@/assets/images/draw1_img3.png) no-repeat;
          background-size: 100% auto;
          left: 4.75rem;
          top: 3.5rem;
        }
        &:nth-child(4) {
          background: url(~@/assets/images/draw1_img4.png) no-repeat;
          background-size: 100% auto;
          top: 5.39rem;
          left: 4.75rem;
        }
        &:nth-child(5) {
          background: url(~@/assets/images/draw1_img5.png) no-repeat;
          background-size: 100% auto;
          left: 4.75rem;
          top: 7.28rem;
        }
        &:nth-child(6) {
          background: url(~@/assets/images/draw1_img6.png) no-repeat;
          background-size: 100% auto;
          top: 7.28rem;
          left: 2.87rem;
        }
        &:nth-child(7) {
          background: url(~@/assets/images/draw1_img7.png) no-repeat;
          background-size: 100% auto;
          top: 7.28rem;
          left: 1rem;
        }
        &:nth-child(8) {
          background: url(~@/assets/images/draw1_img8.png) no-repeat;
          background-size: 100% auto;
          left: 1rem;
          top: 5.39rem;
        }
      }
    }

    // 活动状态
    .status-con {
      width: 100%;
      position: absolute;
      top: 2.05rem;
      left: 0;
      // left: 50%;
      // margin-left: -2.1rem;
      p {
        text-align: center;
        color: #0358dd;
        font-size: 0.26rem;
        line-height: 0.27rem;
        font-weight: bold;
      }
      h5 {
        width: 3.8rem;
        height: 0.36rem;
        background: #fff;
        border-radius: 0.08rem;
        text-align: center;
        color: #3e546a;
        font-size: 0.22rem;
        line-height: 0.36rem;
      }
    }
    .btn {
      position: absolute;
      left: 2.87rem;
      top: 5.39rem;
      width: 1.72rem;
      height: 1.72rem;
      button {
        width: 100%;
        height: 100%;
        border: 0;
        outline: none;
        font-size: 0;
        background-color: transparent;
        &.btn1 {
          background: url(~@/assets/images/draw2_btn1.png) no-repeat;
          background-size: 100% 100%;
        }
        &.btn2 {
          background: url(~@/assets/images/draw2_btn2.png) no-repeat;
          background-size: 100% 100%;
        }
        &.btn3 {
          background: url(~@/assets/images/draw2_btn3.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .zjjl {
      opacity: 0;
      position: absolute;
      top: 9.95rem;
      left: 1.35rem;
      background-color: pink;
      width: 2.07rem;
      height: 0.6rem;
    }
    .cjsm {
      opacity: 0;
      background-color: pink;
      position: absolute;
      right: 1.45rem;
      top: 9.94rem;
      width: 2.07rem;
      height: 0.6rem;
    }
  }
}

// 中奖弹窗
.tc-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  .tc {
    width: 6.2rem;
    height: 3.58rem;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    padding: 0.1rem 0.3rem 0;
    border-radius: 0.2rem;
    text-align: center;
    border: 0.02rem solid #2d66e8;
    .close {
      width: 0.32rem;
      height: 0.28rem;
      position: absolute;
      right: 0;
      top: 0;
    }
    .qycj_succ_dh {
      width: 0.7rem;
      height: 0.7rem;
      display: block;
      margin: 0 auto 0.24rem;
    }
    h4 {
      font-size: 0.4rem;
    }
    h6 {
      color: #2d66e8;
      font-weight: 900;
      font-size: 0.3rem;
      padding: 0.1rem 0;
    }
    p {
      font-size: 0.26rem;
      padding-top: 0.1rem;
    }
  }
}

.show-draw {
  position: absolute;
  top: 2.98rem;
  font-size: 0.22rem;
  color: #ffffff;
  text-align: center;
  width: 4.5rem;
  left: 1.5rem;
}

// .show-draw .swiper-container {
//   width: 4.6rem;
//   height: 1.45rem;
//   margin: 0.85rem auto;
// }
.show-draw .swiper-slide {
  //text-align: center;
  overflow: hidden;
  //text-overflow: ellipsis;
  white-space: nowrap;
  //padding: 0 0.5rem;
  //font-size: 0.2rem;
  //font-weight: 400;
  //line-height: 0.22rem;
}
</style>
